import React, { Suspense, useState } from 'react';
import { useToast } from '../../../../hooks/useToast';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ActionMenu, { Action } from '../../../../components/ui/materialui/actionMenu';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { StatusCode, TipoFuncionalidad } from '../../../../utils/enums';
import { responsables, responsablesEditar } from '../models/responsables';
import { mutuosVigentes } from '../service/servicesResponsables';
import { usePermissions } from '../../../../components/auth/ProtectedRoute';

interface IProps {
  responsables: responsables;
  control: any;
  setResponsablesEditar: React.Dispatch<React.SetStateAction<responsablesEditar | undefined>>;
  setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}

const AccionesResponsables: React.FC<IProps> = ({ responsables, control, setResponsablesEditar, setModalDetalle }) => {

  const { addToast } = useToast();
  const { hasPermission } = usePermissions();
    const puedeEditar = hasPermission(TipoFuncionalidad.Maestros_editar);

  const handleEditarClick = async () => {

    const response = await mutuosVigentes({
      rut: responsables.rut,
      idResponsabilidad: responsables.idResponsabilidad
    });

    if (response.status !== StatusCode.Ok)
      return;

    if (response?.data === true) {
      addToast({
        mostrar: true,
        titulo: 'warning',
        tipo: 'Warning',
        mensaje: 'No se puede modificar responsable, tiene mutuos vigentes.'
      });
      return;
    }

    setResponsablesEditar({
      ...responsables,
    });

    setModalDetalle(true);
  };
   const actions: Action[] = [];
  
    if (puedeEditar) {
      actions.push({
        label: "Editar",
        icon: <EditIcon fontSize="small" />,
        onClick: () => handleEditarClick()
      });
    };

  return (
    <>
      <ActionMenu actions={actions} />
    </>
  );
};

export default AccionesResponsables;
